import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { Button } from "../components/ui/button";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [pw, setPw] = useState("");
  const [msg, setMsg] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token: params.get("token"), new_password: pw });
      setDone(true);
    } catch (err) {
      setMsg(errMsg(err));
    }
  };
  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <form onSubmit={submit} className="w-full max-w-sm rounded-md border bg-white p-6 shadow-sm" data-testid="reset-password-form">
        <h2 className="mb-4 text-xl font-semibold">Set a new password</h2>
        {done ? (
          <p className="text-sm text-emerald-700">Password updated. <Link className="text-sky-700 underline" to="/login">Sign in</Link></p>
        ) : (
          <>
            <input data-testid="reset-password-input" type="password" className="otms-input" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password" />
            {msg && <p className="mt-2 text-xs text-red-600">{msg}</p>}
            <Button data-testid="reset-password-submit" className="mt-4 w-full bg-sky-600 hover:bg-sky-700" type="submit">Update password</Button>
          </>
        )}
      </form>
    </div>
  );
}
